export default __webpack_public_path__ + "static/media/redo.f2ab1feb.svg";